<mat-form-field [ngClass]="formFieldClass" [ngClass]="{'overwrite-suffix-prefix-styles' : label}">
  <label *ngIf="label" for="{{controlName}}">
    {{label}}
    <span *ngIf="required" class="required">*</span>
    <span *ngIf="isToolTipRequired" matTooltip="{{tooltipText}}"
      matTooltipPosition="{{tooltipConfig?.position}}">
      <mat-icon color="primary">info</mat-icon>
    </span>
  </label>
  <input
    id="{{controlName}}"
    matInput
    type="text"
    [ngStyle]="customStyles"
    [maskito]="maskitoCurrencyOptions"
    [(ngModel)]="value"
    (focus)="onFocus($event.target.value)"
    (blur)="onTouchedCallback();onBlur($event.target.value)"
    [disabled]="disabled"
    (ngModelChange)="innerModelChanged()"
  />
  <span *ngIf="suffix" matSuffix>{{suffix}}</span>
</mat-form-field>
